import {
  AccountBalanceWallet,
  ArrowForward,
  CenterFocusStrong,
  Keyboard,
  MeetingRoom,
  Info,
  PhoneAndroid,
  Receipt,
  Storage,
  Archive,
} from '@material-ui/icons'
import { Fence } from '@mui/icons-material'
import React from 'react'
import { DeviceTypes } from '../enum/DeviceTypes'

export const getDeviceIcon = (deviceType: DeviceTypes): JSX.Element => {
  switch (deviceType) {
    case DeviceTypes.BARRIERS:
      return <Fence />
    case DeviceTypes.CAMERA:
      return <CenterFocusStrong />
    case DeviceTypes.CAMERA_SERVER:
      return <Storage />
    case DeviceTypes.DEPOSITOR:
      return <Archive />
    case DeviceTypes.DETECTOR:
      return <CenterFocusStrong />
    case DeviceTypes.DOORS:
      return <MeetingRoom />
    case DeviceTypes.ENGINE:
      return <AccountBalanceWallet />
    case DeviceTypes.IKSORIS_PARKING_TICKET_CASH_MACHINE:
      return <Receipt />
    case DeviceTypes.IKSORIS_PARKING_TICKET_CASHLESS_MACHINE:
      return <AccountBalanceWallet />
    case DeviceTypes.OFFLINE_SERVER:
      return <Storage />
    case DeviceTypes.PALM:
      return <PhoneAndroid />
    case DeviceTypes.PASSAGE:
      return <ArrowForward />
    case DeviceTypes.SELFPOS_ACCESS_TICKET_CASHLESS_MACHINE:
      return <AccountBalanceWallet />
    case DeviceTypes.TERMINALS:
      return <Keyboard />
    default:
      return <Info />
  }
}
